import { ref } from 'vue';
import { fetchApi } from '../utils/api';
import { API_BASE_URL, STORE_ID, setStoreId } from '../config';

const storeConfig = ref(null);
const currentStoreId = ref(STORE_ID);

export const useStoreConfig = () => {
  const fetchStoreConfig = async () => {
    if (storeConfig.value) return storeConfig.value;
    try {
      // Fetch all stores to match by domain
      const storesRes = await fetchApi(`${API_BASE_URL}?action=getStore`);
      const storesData = await storesRes.json();

      

      let matchedStoreId = STORE_ID; // Fallback to default
      if (storesData.success && storesData.data && storesData.data.length > 0) {
        const hostname = window.location.hostname;
        const matchedStore = storesData.data.find(s => {
          if (!s.domain) return false;
          // Clean domains for comparison
          const sDomain = s.domain.toLowerCase().replace(/^https?:\/\//, '').replace(/^www./, '').split('/')[0];
          const currDomain = hostname.toLowerCase().replace(/^www./, '');
          return sDomain === currDomain || sDomain === 'localhost' || currDomain === 'localhost'; // fallback for dev
        });

        if (matchedStore) {
          matchedStoreId = matchedStore.id;
          setStoreId(matchedStoreId);
          currentStoreId.value = matchedStoreId;
        } else if (hostname === 'localhost' || hostname === '127.0.0.1') {
          // In development, might just pick the first one if not matched
          matchedStoreId = storesData.data[0].id;
          setStoreId(matchedStoreId);
          currentStoreId.value = matchedStoreId;
        }
      }

      const response = await fetchApi(`${API_BASE_URL}?action=getStore&id=${matchedStoreId}`);
      const data = await response.json();
      if (data.success) {
        storeConfig.value = data.data;
      }
    } catch (error) {
      console.error('Error fetching store config:', error);
    }
    return storeConfig.value;
  };

  return {
    storeConfig,
    currentStoreId,
    fetchStoreConfig,
  };
};
